export default __webpack_public_path__ + "static/media/laptop.90842c5c.svg";